import { render } from "./MiddleBar.vue?vue&type=template&id=dfd2f66e&scoped=true"
import script from "./MiddleBar.vue?vue&type=script&lang=js"
export * from "./MiddleBar.vue?vue&type=script&lang=js"

import "./MiddleBar.vue?vue&type=style&index=0&id=dfd2f66e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd2f66e"]])

export default __exports__